export default __webpack_public_path__ + "static/media/cross.47d5c9aa.svg";